module.exports = __webpack_public_path__ + "img/guest-modal-pop-up.dc95c206.svg";